import React, { useEffect, useState } from "react";
import ProfileOverview from "./components/ProfileOverview";
import CurrentWorkoutPlan from "./components/CurrentWorkoutPlan";
import StatsCard from "./components/StatsCard";
import MeditationTracking from "./components/MeditationTracking";
import PreviousWorkouts from "./components/PreviousWorkouts";
import PlanHistory from "./components/PlanHistory";
import BookmarkedWorkoutsAndRecipes from "./components/BookmarkedWorkoutsAndRecipes";
import WorkoutRoutineCard from "./components/WorkoutRoutineCard";
import UserInfo from "./components/UserInfo";
import { useParams } from "react-router-dom";
import { fetchUserById } from "../../api/userProfile";

const UserDetails = () => {
  const { userId } = useParams();


  const [userData, setUserData] = useState(null);
  const [, setLoading] = useState(true);
  const [setError] = useState(null);

  let fetchUserData;
  fetchUserData = async () => {
    try {
      const data = await fetchUserById(userId);
      setUserData(data);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (userId) {
      fetchUserData().then();
    }
  }, [fetchUserData, userId]);

  return (
    <div className="right-side-wrapper">
      <div className="container-fluid">
        <div className="row">
          <div className="col-lg-3 mb-4">
            <ProfileOverview userId={userId} userData ={userData} />
            <WorkoutRoutineCard userId={userId} />
            <UserInfo userId={userId} userData ={userData}  />
          </div>

          <div className="col-lg-9">
            <CurrentWorkoutPlan userId={userId} />
            <StatsCard userId={userId} />
            <div className="row">
              <div className="col-lg-6">
                <MeditationTracking />
              </div>
              <div className="col-lg-6">
                <PreviousWorkouts />
              </div>
            </div>
            <PlanHistory userId={userId} />
            <BookmarkedWorkoutsAndRecipes />
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserDetails;
